<script setup lang="ts">
import { isMobile } from "@/utils/main";

const downloadLinkDefault = 'https://staff.vitaexpress.ru/';
const appLinks = {
  ios: 'https://apps.apple.com/ru/app/%D0%BF%D0%BB%D0%B0%D0%BD%D0%B5%D1%82%D0%B0-%D0%B2%D0%B8%D1%82%D0%B0/id1581593643',
  android: 'https://play.google.com/store/apps/details?id=ru.aptekivita.vitastaffandroidnative',
  ruStore: 'https://www.rustore.ru/catalog/app/ru.aptekivita.vitastaffandroidnative',
  appGallery: 'https://appgallery.huawei.com/#/app/C107156587'
};

const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
const isAndroid = /Android/.test(navigator.userAgent);

const downloadApp = () => {
  const downloadLink = isIOS ? appLinks.ios : isAndroid ? appLinks.android : downloadLinkDefault;
  if (isMobile) {
    window.location.href = downloadLink;
  } else {
    window.open(downloadLink, '_blank');
  }
};
</script>

<template>
  <div class="mobile-screen">
    <div>
      <img width="234" height="77" alt="Вита" src="@/static/img/logo.svg" />
    </div>
    <div>
      <div class="mobile-screen-text">График сотрудников можно посмотреть в мобильном приложении “Планета Вита”</div>
      <vita-button @click="downloadApp" type="medium"
                   data-qa="mobile-screen-button-open-app">Открыть в приложении</vita-button>
    </div>
    <div>
      <div>
        <div class="mobile-screen-text muted">Нет приложения? <br>
          Скачивайте на устройство</div>
      </div>
      <div v-if="isIOS">
        <a :href="appLinks.ios" target="_blank" data-qa="mobile-screen-link-app-store">
          <img src="@/static/img/store/appStore.svg" alt="Загрузите в App Store">
        </a>
      </div>
      <div v-else>
        <ul>
          <li>
            <a :href="appLinks.android" target="_blank" data-qa="mobile-screen-link-google-play">
              <img src="@/static/img/store/googlePlay.svg" alt="Доступно в Google Play">
            </a>
          </li>
          <li>
            <a :href="appLinks.ruStore" target="_blank" data-qa="mobile-screen-link-ru-store">
              <img src="@/static/img/store/ruStore.svg" alt="Доступно в RuStore">
            </a>
          </li>
          <li>
            <a :href="appLinks.appGallery" target="_blank" data-qa="mobile-screen-link-app-gallery">
              <img src="@/static/img/store/appGallery.svg" alt="Откройте в AppGallery">
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mobile-screen {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  padding: 0 50px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #333333;

  > div {
    max-width: 301px;
  }

  > :first-child {
    margin-top: 100px;
  }

  > :last-child {
    margin-bottom: 48px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.mobile-screen-text {
  margin-bottom: 16px;

  &.muted {
    color: rgba(136, 136, 136, 1);
  }
}
</style>